import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { useAppContext } from "./../AppContext"; // Adjust the path as needed
import LemaqLogonobackground from "./../Images/LemaqLogonobackground.png";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { MyDomain } from "../App";

export default function LeftSide() {
  const [height, width] = useWindowSize();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [height]);

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const history = useHistory();
  const { setUser, setToken } = useAppContext();
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLogin = async (email, password) => {
    const data = {
      Email: email,
      Password: password,
    };
    console.log(data);
    try {
      const response = await axios.post(`${MyDomain}Users/Login`, data);
      const { token } = response.data;
      const decodedToken = jwtDecode(token);
      setUser(decodedToken); // Store user data in context
      setToken(token); // Store token in context
      if (token) {
        // Save token and user data in localStorage
        localStorage.setItem("token", token);
        localStorage.setItem("role", decodedToken.role);
        localStorage.setItem("user", JSON.stringify(decodedToken));
        // Redirect based on role
        if (decodedToken.role === "Admin") {
          history.push("/admin-mainpage/admin-dashboard");
        } else if (decodedToken.role === "Student") {
          history.push("/student-dashboard");
        } else if (decodedToken.role === "Delivery") {
          history.push("/delivery-mainpage/delivery-dashboard");
        } else {
          alert("Unknown role. Please contact support.");
        }
      }
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      alert("Invalid credentials. Please try again.");
    }
  };

  const GoToSignupPage = () => {
    history.push("/signupPage");
  };
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        height: "100hv",
        width: "50%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <img
          style={{
            width: "50%",
            height: "50%",
            paddingTop: "5%",
            // filter:
            //   "invert(60%) sepia(100%) saturate(250%) hue-rotate(-65deg) brightness(90%) contrast(85%)",
          }}
          src={LemaqLogonobackground}
          alt="BarRabbitsITImages"
        />
        <h2>Login</h2>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: width < 768 ? "100%" : "80%",
          }}
        >
          <p>Email</p>
        </div>
        <TextField
          value={Email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: width < 768 ? "100%" : "80%",
          }}
          id="outlined-basic"
          label="Enter your email"
          variant="outlined"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: width < 768 ? "100%" : "80%",
          }}
        >
          <p>Password</p>
        </div>
        <FormControl
          style={{ width: width < 768 ? "100%" : "80%", borderRadius: 50 }}
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-password">
            Enter your password
          </InputLabel>
          <OutlinedInput
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            id="outlined-adornment-password"
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Enter your password"
          />
        </FormControl>
        <div
          style={{
            width: width < 768 ? "100%" : "80%",
            flex: 1,
            display: "flex",
            paddingTop: "5%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            style={{
              height: 45,
              width: "100%",
              backgroundColor: "black",
              textTransform: "none",
              fontSize: "100%",
              borderRadius: "12px",
            }}
            variant="contained"
            onClick={() => {
              handleLogin(Email, Password);
            }}
          >
            Login
          </Button>
        </div>

        {/* <div
          style={{
            //width: width < 768 ? "100%" : "80%",
            flex: 1,
            display: "flex",
            marginTop: width < 768 ? "35%" : "10%",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <a
            style={{ color: "#6b21a8" }}
            onClick={() => {
              GoToSignupPage();
            }}
          >
            Create new account
          </a>
        </div> */}
      </div>
    </div>
  );
}
